import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.attributes"))),
      ]),
      _vm._t("default"),
      _c(VBreadcrumbs, {
        staticClass: "pa-0 text--black",
        attrs: { items: _vm.getBreadcrumbs },
      }),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0 mt-2 text--black",
                  attrs: { items: _vm.breadcrums },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onSelectAll },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-add"),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("botones.boton_select_all")) + " "
                    ),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onDownloadFile },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-download"),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("botones.boton_download")) + " "
                    ),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onEnableFilter },
                  },
                  [
                    _vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-off-outline"),
                        ])
                      : _vm._e(),
                    !_vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-outline"),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, { staticClass: "mt-2" }, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    disabled: _vm.isLoading,
                    headers: _vm.headers,
                    "items-per-page": _vm.filtro.per_page,
                    items: _vm.encontrado.busqueda,
                    loading: _vm.isLoading,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    responsive: "",
                    rounded: "",
                    "sort-by": _vm.sort_by,
                    id: "fooAnchor",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header.status",
                      fn: function (ref) {
                        var header = ref.header
                        return [
                          _c(
                            VIcon,
                            {
                              attrs: { medium: "" },
                              on: { click: _vm.addAllItem },
                            },
                            [_vm._v("icon-add")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.descripcion",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.more_data2["business"] &&
                                  item.more_data2["business"]["Descripción"]
                                  ? item.more_data2["business"]["Descripción"]
                                  : item.descripcion
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.no_nulo",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.no_nulo === -1
                                  ? "-"
                                  : Math.round(item.no_nulo) + "%"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.status",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(VHover, {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var hover = ref.hover
                                    return [
                                      _c(
                                        VIcon,
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            medium: "",
                                            color:
                                              item.status && hover
                                                ? "#F03063"
                                                : item.status && !hover
                                                ? "#0021CF"
                                                : !item.status && !hover
                                                ? "#4B4D53"
                                                : "#0021CF",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addItem(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.status && hover
                                                  ? "mdi-minus-circle-outline"
                                                  : item.status && !hover
                                                  ? "mdi-check-circle-outline"
                                                  : !item.status && !hover
                                                  ? "icon-add"
                                                  : "mdi-check-circle-outline"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      },
                    },
                    {
                      key: "item.more",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("p", [
                            _c(
                              "ul",
                              { staticClass: "m-0 pl-2" },
                              _vm._l(item.more_data, function (a) {
                                return _c("li", [
                                  _c("b", [_vm._v(_vm._s(a[0]) + ": ")]),
                                  _vm._v(
                                    _vm._s(
                                      typeof item.more_data2.business[a[0]] ==
                                        "string"
                                        ? item.more_data2.business[a[0]]
                                        : typeof item.more_data2.relation[
                                            a[0]
                                          ] == "string"
                                        ? item.more_data2.relation[a[0]]
                                        : ""
                                    ) + " "
                                  ),
                                  typeof item.more_data2.business[a[0]] ==
                                  "object"
                                    ? _c(
                                        "ul",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._l(
                                            item.more_data2.business[a[0]],
                                            function (v, key2) {
                                              return typeof v == "string"
                                                ? _c("li", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(key2) + ": "
                                                      ),
                                                    ]),
                                                    _vm._v(_vm._s(v) + " "),
                                                  ])
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._l(
                                            item.more_data2.business[a[0]],
                                            function (v, key2) {
                                              return typeof v == "object"
                                                ? _c("li", [
                                                    _c(
                                                      "ul",
                                                      { staticClass: "pl-0" },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(key2) + ": "
                                                          ),
                                                        ]),
                                                        _vm._l(
                                                          v,
                                                          function (item2) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                staticClass:
                                                                  "ml-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(item2)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ])
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  typeof item.more_data2.relation[a[0]] ==
                                  "object"
                                    ? _c(
                                        "ul",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._l(
                                            item.more_data2.relation[a[0]],
                                            function (v, key2) {
                                              return typeof v == "string"
                                                ? _c("li", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(key2) + ": "
                                                      ),
                                                    ]),
                                                    _vm._v(_vm._s(v) + " "),
                                                  ])
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._l(
                                            item.more_data2.relation[a[0]],
                                            function (v, key2) {
                                              return typeof v == "object"
                                                ? _c("li", [
                                                    _c(
                                                      "ul",
                                                      { staticClass: "pl-0" },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(key2) + ": "
                                                          ),
                                                        ]),
                                                        _vm._l(
                                                          v,
                                                          function (item2) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                staticClass:
                                                                  "ml-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(item2)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ])
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ])
                              }),
                              0
                            ),
                          ]),
                          _c(
                            VIcon,
                            {
                              staticClass: "pointer pl-1",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onOpenModalAdditionalData(item)
                                },
                              },
                            },
                            [_vm._v("mdi-information")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                [
                  _c(
                    "div",
                    { staticClass: "text-left mt-3 pb-2" },
                    [
                      Math.ceil(
                        _vm.encontrado.found / _vm.encontrado.per_page
                      ) > 1
                        ? _c(VPagination, {
                            attrs: {
                              length: Math.ceil(
                                _vm.encontrado.found / _vm.encontrado.per_page
                              ),
                              circle: "",
                              "total-visible": "5",
                            },
                            on: { input: _vm.next },
                            model: {
                              value: _vm.encontrado.page,
                              callback: function ($$v) {
                                _vm.$set(_vm.encontrado, "page", $$v)
                              },
                              expression: "encontrado.page",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
              ],
              2
            ),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                      ),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { staticClass: "mb-2" },
                              [
                                _c(VTextField, {
                                  ref: "search",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "attributes.label.search"
                                    ),
                                    "prepend-inner-icon": "icon-search",
                                    "hide-details": "",
                                    filled: "",
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.sendToSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.q,
                                    callback: function ($$v) {
                                      _vm.q = $$v
                                    },
                                    expression: "q",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    multiple: "",
                                    label: _vm.$t("attributes.label.category"),
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.categories,
                                    "item-value": "id",
                                    "item-text": "name",
                                    "hide-details": "",
                                  },
                                  on: { change: _vm.sendToSearch },
                                  model: {
                                    value: _vm.filtro.category,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filtro, "category", $$v)
                                    },
                                    expression: "filtro.category",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.has_semantic_search_active
                              ? _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VSwitch, {
                                      attrs: {
                                        label: _vm.$t(
                                          "attributes.label.semantic_search"
                                        ),
                                        outlined: "",
                                      },
                                      on: { change: _vm.sendToSearch },
                                      model: {
                                        value: _vm.filtro.semantic_search,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "semantic_search",
                                            $$v
                                          )
                                        },
                                        expression: "filtro.semantic_search",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary ",
                                    on: { click: _vm.sendToSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_SEE_REPORT_DETAIL,
        attrs: {
          title: _vm.$t("titles.use_case_report"),
          "show-buttons": true,
          width: 1024,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [_c("use-case-detail-component")]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: "DIALOG_DATOS_ADICIONALES",
        attrs: {
          title: "Datos Adicionales: " + _vm.attr_selected.nombre,
          width: 800,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("h6", [_vm._v("Metadata de Negocio")]),
                _c(
                  "ul",
                  { staticClass: "m-0 pl-2 mb-2" },
                  _vm._l(
                    _vm.attr_selected.more_data2.business,
                    function (value, key) {
                      return _c(
                        "li",
                        {
                          style: {
                            "margin-left":
                              key == "Tipo de Atributo Cuantitativo"
                                ? "30px"
                                : "0px",
                          },
                        },
                        [
                          _c("b", [_vm._v(_vm._s(key) + ": ")]),
                          _vm._v(_vm._s(value) + " "),
                        ]
                      )
                    }
                  ),
                  0
                ),
                _c("h6", [_vm._v("Objetos Relacionados")]),
                _c(
                  "ul",
                  { staticClass: "m-0 pl-2" },
                  _vm._l(
                    _vm.attr_selected.more_data2.relation,
                    function (value, key) {
                      return _c("li", [
                        _c("b", [_vm._v(_vm._s(key) + ": ")]),
                        _vm._v(
                          _vm._s(typeof value == "string" ? value : "") + " "
                        ),
                        typeof value == "object"
                          ? _c(
                              "ul",
                              { staticClass: "pl-2" },
                              [
                                _vm._l(value, function (v, key2) {
                                  return typeof v == "string"
                                    ? _c("li", [
                                        _c("b", [_vm._v(_vm._s(key2) + ": ")]),
                                        _vm._v(_vm._s(v) + " "),
                                      ])
                                    : _vm._e()
                                }),
                                _vm._l(value, function (v, key2) {
                                  return typeof v == "object"
                                    ? _c("li", [
                                        _c(
                                          "ul",
                                          { staticClass: "pl-0" },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(key2) + ": "),
                                            ]),
                                            _vm._l(v, function (item) {
                                              return _c(
                                                "li",
                                                { staticClass: "ml-2" },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            }),
                                          ],
                                          2
                                        ),
                                      ])
                                    : _vm._e()
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    }
                  ),
                  0
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: "MODAL_SELECT_ALL",
        attrs: { title: "Seleccionar Todos" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c(VCol, [
                      _vm._v(
                        " Se cargaron " +
                          _vm._s(_vm.attr_loaded) +
                          " atributos de " +
                          _vm._s(_vm.total_to_load) +
                          ". "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  VRow,
                  [
                    _c(
                      VCol,
                      [
                        _c(VProgressLinear, {
                          attrs: {
                            value: _vm.progress_all,
                            "buffer-value": "0",
                            stream: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }